import { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { getAuthToken } from "../utils/utils"
import AdminLayout from "../layouts/AdminLayout"

interface AuthGuardProps {
  children: React.ReactNode
}

const AuthGuard: React.FC<AuthGuardProps> = ({ children }) => {
  const navigate = useNavigate()

  useEffect(() => {
    const token = getAuthToken()
    if (!token) {
      navigate("/login")
    }
  }, [navigate])

  return <AdminLayout>{children}</AdminLayout>
}

export default AuthGuard
